import { useState, useCallback } from 'react';
import fetchWithCsrf from 'js/utils/fetch_with_csrf';
import routes from 'js/core_pre_webpack/routes';

type Citation = {
  name: string;
  citation: string;
};

export const useCitations = (workId: number) => {
  const [citations, setCitations] = useState<Citation[]>([]);

  const loadCitations = useCallback(async () => {
    const response = await fetchWithCsrf(
      routes.citations_api_v0_work_path({
        id: workId,
        subdomain_param: 'api',
      }),
    );

    const data = await response.json();
    setCitations(data.citations);
  }, [workId]);

  return {
    citations,
    loadCitations,
  };
};
